import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';

import WithLabel, { LABEL_STYLES } from '../../../../components/with-label/WithLabel';
import WithError from '../../../../components/with-error/WithError';
import CommonTextarea from '../../../../components/common-textarea/CommonTextarea';
import TooltipButton from '../../../../components/tooltip-button/TooltipButton';
import { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';

import scss from './Navig8Form.module.scss';

function Navig8FormInner({ onSubmit }) {
  const { t } = useTranslation('sonar');

  const navig8AbortController = useSelector((state) => state.sonarDashboard.navig8AbortController);

  const isLoading = Boolean(navig8AbortController);

  return (
    <div className={scss.wrapper}>
      <Field name='hint'>
        {({ input, meta }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label='NAVIG8:' isBold extraClassName={scss.hintsField}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                isReadOnly
                rows='3'
                resize='vertical'
                isError={meta.touched && meta.error}
                disabled={isLoading}
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <Field name='reply'>
        {({ meta, input }) => (
          <WithLabel variant={LABEL_STYLES.ROW} label={`${t('you')}:`} isBold extraClassName={scss.hintsField}>
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonTextarea
                name={input.name}
                value={input.value}
                onChange={input.onChange}
                rows='3'
                resize='vertical'
                isError={meta.touched && meta.error}
                disabled={isLoading}
                enableVoiceInput
              />
            </WithError>
          </WithLabel>
        )}
      </Field>

      <TooltipButton
        type='submit'
        styleColor={BUTTON_STYLES.SECONDARY}
        onClick={onSubmit}
        maxWidth={140}
        disabled={isLoading}
        tooltip={isLoading && t('messagesGenerating')}>
        <Icon icon={ICONS.ArrowUp} />
      </TooltipButton>
    </div>
  );
}

export default Navig8FormInner;
